import { render, staticRenderFns } from "./curationPage.vue?vue&type=template&id=42985d07&scoped=true&"
import script from "./curationPage.vue?vue&type=script&lang=js&"
export * from "./curationPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42985d07",
  null
  
)

export default component.exports